module.exports = __webpack_public_path__ + "NeueFrutigerWorld-BookIt.47a9f2fedd39a32993c8.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-BookIt.ttf
// module id = ../../../../../src/assets/fonts/neue-frutiger-world/NeueFrutigerWorld-BookIt.ttf
// module chunks = styles